import React, { Component } from 'react'
import { func, object } from 'prop-types'
import { translate } from 'react-i18next'
import { Link } from 'react-router-dom'
import { stores, view } from '../../stores'
import { PagesPaths } from '../../constants/Pages'
import { isValidPricing, getPricingValues, formatPricingAfterTax, formatRating, getVisibleServices } from '../../utilities/gardener-seo'
import './GardenerItem.css'

var CheckIcon = function () {
  return (
    <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
  )
}

class GardenerItem extends Component {
  render () {
    var j = this.props.jardinier
    var id = j.id
    var externalId = j.externalId
    var name = (j.name || '').trim()
    var pictureFile = j.pictureFile
    var pricing = j.pricing
    var seniority = j.seniority
    var isPremium = j.premium || j.isPremium
    var proposedServices = j.proposedServices || []
    var interventionsCount = j.interventionsCount
    var city = stores.search.search.city
    var postalCode = stores.search.search.postalCode
    // Keyed by entityRelationId, which is exactly the id the search returns for a professional.
    // Absent for professionals without reviews: nothing is displayed then.
    var rating = (stores.search.ratings || {})[id]
    var hasRating = !!rating && rating.count > 0

    var profileUrl = PagesPaths.GARDENER.path + '/' + (externalId || id)
    var checked = stores.search.selected.indexOf(id) !== -1
    var initial = name ? name.charAt(0).toUpperCase() : '?'

    var pricingValues = getPricingValues(pricing)
    var pricingValid = isValidPricing(pricing)
    var servicesTags = getVisibleServices(proposedServices, 5)

    var cardClass = 'gardener-card'
    if (isPremium) cardClass += ' gardener-card--premium'
    if (checked) cardClass += ' gardener-card--selected'

    var handleCardClick = function (e) {
      if (e.target.closest('.gardener-card__cta')) return
      stores.search.toggle({ id: id })
    }

    return (
      <div className={cardClass} itemScope itemType="https://schema.org/ProfessionalService" onClick={handleCardClick}>
        {/* Selection toggle */}
        <div className="gardener-card__select">
          <span className={'gardener-card__select-toggle' + (checked ? ' gardener-card__select-toggle--checked' : '')}>
            <svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12" /></svg>
          </span>
        </div>

        <div className="gardener-card__body">
          {/* Header: avatar + info */}
          <div className="gardener-card__header">
            <div className="gardener-card__avatar-link">
              {pictureFile && pictureFile.path
                ? <img className="gardener-card__avatar" src={pictureFile.path} alt={name} itemProp="image" loading="lazy" />
                : <div className="gardener-card__avatar-placeholder">{initial}</div>
              }
            </div>
            <div className="gardener-card__info">
              <div className="gardener-card__name-row">
                <span className="gardener-card__name" itemProp="name">{name}</span>
                {isPremium && (
                  <span className="gardener-card__badge">{'\u2B50'} Premium</span>
                )}
              </div>
              <div className="gardener-card__meta" itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
                <b itemProp="addressLocality">{city}</b> (<span itemProp="postalCode">{postalCode}</span>)
                {seniority > 0 ? ' - ' + seniority + ' ans d\'expérience' : ''}
              </div>
              {hasRating && (
                <div
                  className="gardener-card__stars"
                  itemProp="aggregateRating"
                  itemScope
                  itemType="https://schema.org/AggregateRating"
                  aria-label={'Note ' + formatRating(rating.average) + ' sur 5 pour ' + rating.count + ' avis'}
                >
                  <span className="gardener-card__stars-icons" aria-hidden="true">{'\u2605'}</span>
                  <span className="gardener-card__stars-value">{formatRating(rating.average)}</span>
                  <span className="gardener-card__stars-count">({rating.count} avis)</span>
                  <meta itemProp="ratingValue" content={rating.average.toFixed(1)} />
                  <meta itemProp="reviewCount" content={String(rating.count)} />
                  <meta itemProp="bestRating" content="5" />
                  <meta itemProp="worstRating" content="1" />
                </div>
              )}
            </div>
          </div>

          {/* Tags */}
          {servicesTags.visible.length > 0 && (
            <div className="gardener-card__tags">
              {servicesTags.visible.map(function (service, i) {
                return <span key={i} className="gardener-card__tag">{service}</span>
              })}
              {servicesTags.overflow > 0 && (
                <span className="gardener-card__tag gardener-card__tag--overflow">+{servicesTags.overflow}</span>
              )}
            </div>
          )}

          {/* Credentials */}
          {interventionsCount > 0 && (
            <div className="gardener-card__credentials">
              <div className="gardener-card__credential">
                <div className="gardener-card__credential-icon"><CheckIcon /></div>
                {interventionsCount} interventions
              </div>
            </div>
          )}

          {/* Pricing row */}
          <div className="gardener-card__pricing-row">
            <span className="gardener-card__pricing-label">Tarif horaire</span>
            <div className="gardener-card__pricing-values">
              {pricingValid && pricingValues ? (
                <div>
                  <span className="gardener-card__pricing-old">{pricingValues.min}-{pricingValues.max}{'\u20AC'}/h</span>
                  <span className="gardener-card__pricing-new">{formatPricingAfterTax(pricingValues.min)}-{formatPricingAfterTax(pricingValues.max)}{'\u20AC'}/h</span>
                  <span className="gardener-card__pricing-credit">après crédit d'impôt 50%</span>
                </div>
              ) : (
                <span className="gardener-card__pricing-quote">Sur devis</span>
              )}
            </div>
          </div>
        </div>

        {/* CTA Footer */}
        <div className="gardener-card__footer">
          <Link to={profileUrl} className="gardener-card__cta" onClick={function (e) { e.stopPropagation() }}>
            Voir le profil
          </Link>
          <div className="gardener-card__cta-sub">Gratuit - Sans engagement</div>
        </div>
      </div>
    )
  }
}

GardenerItem.propTypes = {
  t: func,
  jardinier: object
}

export default translate()(view(GardenerItem))



// WEBPACK FOOTER //
// ./src/components/gardeners/GardenerItem.js